export * from './pwd';
import CreateAPI from 'vue-create-api';
import PwdDialog from './PwdDialog.vue';

PwdDialog.install = function (Vue) {
  if (!Vue.prototype.$createPwdDialog) {
    Vue.use(CreateAPI, {
      componentPrefix: 'vu-',
      apiPrefix: '$create-'
    });
    Vue.createAPI(PwdDialog, ['cancel', 'close'], true);
  }
};

export default PwdDialog;